'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _pacomo = require('utils/pacomo');

var _bookingDataActions = require('actions/bookingDataActions');

var _forms = require('metadata/forms');

var _forms2 = require('utils/forms');

var _components2 = require('components');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ContactInformation: {
        displayName: 'ContactInformation'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/RequirementSet/forms/ContactInformation.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

// const syncValidation = formSyncValidation({
//     requiredValues: ['dateOfBirth', 'nationality'],
//     dateValues: [
//         { value: 'dateOfBirth' }
//     ]
//     requirements: {
//         NAME: ['']
//     }
// })

var mobilePhoneRenderProps = (0, _forms2.objInArrayFieldProps)({
    findProp: 'type',
    findValue: 'Cell',
    valueProp: 'number',
    WrappedComponent: _components2.Input
});
var homePhoneRenderProps = (0, _forms2.objInArrayFieldProps)({
    findProp: 'type',
    findValue: 'Home',
    valueProp: 'number',
    WrappedComponent: _components2.Input
});
var mecMembershipRenderProps = (0, _forms2.objInArrayFieldProps)({
    findProp: 'code',
    findValue: 'MEC_MEMBERSHIP_NUMBER',
    valueProp: 'value',
    WrappedComponent: _components2.Input
});

var ContactInformation = _wrapComponent('ContactInformation')((_dec = (0, _reduxForm.reduxForm)({
    form: 'ContactInformation',
    enableReinitialize: true
}), _dec(_class = (0, _reactIntl.injectIntl)(_class = (0, _pacomo.pacomoDecorator)(_class = function (_React$Component) {
    (0, _inherits3.default)(ContactInformation, _React$Component);

    function ContactInformation(props) {
        (0, _classCallCheck3.default)(this, ContactInformation);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ContactInformation.__proto__ || (0, _getPrototypeOf2.default)(ContactInformation)).call(this, props));

        _this.setCountryId = _this.setCountryId.bind(_this);

        if (!(typeof _this.setCountryId === 'function')) {
            throw new TypeError('Value of "this.setCountryId" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.setCountryId));
        }

        return _this;
    }

    (0, _createClass3.default)(ContactInformation, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.setCountryId(this.props);
        }
    }, {
        key: 'setCountryId',
        value: function setCountryId(props) {
            var requirementsByCode = props.requirementsByCode;

            var countryId = null;

            if (requirementsByCode.COUNTRY_OF_RESIDENCE && requirementsByCode.COUNTRY_OF_RESIDENCE.status === 'COMPLETE') {
                var fieldValuesByResourceType = requirementsByCode.COUNTRY_OF_RESIDENCE.fieldValuesByResourceType;

                countryId = fieldValuesByResourceType.customers['address.country.id'].value;
            }

            this.setState({
                countryId: countryId
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                intl = _props.intl,
                paxProfile = _props.paxProfile,
                initialValues = _props.initialValues,
                hiddenValues = _props.hiddenValues,
                requirementsByCode = _props.requirementsByCode,
                bookingId = _props.bookingId,
                isFetchingRequirementData = _props.isFetchingRequirementData,
                handleSubmit = _props.handleSubmit,
                error = _props.error,
                invalid = _props.invalid,
                pristine = _props.pristine,
                submitSucceeded = _props.submitSucceeded,
                submitFailed = _props.submitFailed,
                submitting = _props.submitting;


            var patchHrefs = {
                EMAIL_ADDRESS: requirementsByCode.EMAIL_ADDRESS.fieldResourceHrefsByType.customers,
                ADDRESS: requirementsByCode.ADDRESS.fieldResourceHrefsByType.customers,
                COUNTRY_OF_RESIDENCE: requirementsByCode.ADDRESS.fieldResourceHrefsByType.customers,
                PHONE_NUMBERS: requirementsByCode.ADDRESS.fieldResourceHrefsByType.customers
            };

            var mecMembershipNumberReq = requirementsByCode.MEC_MEMBERSHIP_NUMBER;

            var phoneNumberOverride = (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                intl: intl,
                id: 'phoneNumberOverride',
                requirement: requirementsByCode.PHONE_NUMBERS,
                overrideLabels: _forms.formOverrides.contactInformation.PHONE_NUMBERS,
                bookingId: bookingId,
                initialValues: initialValues
            }));

            var phoneReqIsComplete = requirementsByCode.PHONE_NUMBERS.status === 'COMPLETE';
            var showPhoneOverride = phoneNumberOverride && !phoneNumberOverride.hideField;

            var showAlert = false; // switch to enable/disable alerts

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.FormErrorMessage, { errorCode: error, invalid: invalid, submitFailed: submitFailed, submitting: submitting }),
                _react3.default.createElement(
                    'form',
                    null,
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: requirementsByCode.EMAIL_ADDRESS,
                        fields: [{
                            id: 'accountEmail',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.emailAddress',
                                defaultMessage: 'Email Address' }),
                            field: _react3.default.createElement(_reduxForm.Field, {
                                id: 'accountEmail',
                                name: '[\'' + patchHrefs.EMAIL_ADDRESS + '\'].account_email',
                                hiddenValues: hiddenValues,
                                component: _components2.Input,
                                type: 'email',
                                requirement: requirementsByCode.EMAIL_ADDRESS })
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'emailOverride',
                            requirement: requirementsByCode.EMAIL_ADDRESS,
                            overrideLabels: _forms.formOverrides.contactInformation.EMAIL_ADDRESS,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: requirementsByCode.COUNTRY_OF_RESIDENCE,
                        fields: [{
                            id: 'countryOfRes',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.countryOfRes',
                                defaultMessage: 'Country of Residence' }),
                            field: _react3.default.createElement(_reduxForm.Field, {
                                id: 'countryOfRes',
                                name: '[\'' + patchHrefs.COUNTRY_OF_RESIDENCE + '\'].address.country.id',
                                hiddenValues: hiddenValues,
                                component: _components2.SelectCachedInput,
                                loadResource: 'countries',
                                fuzzyParam: 'name',
                                normalize: function normalize(value) {

                                    _this2.props.dispatch((0, _bookingDataActions.setCountryId)(value || null));
                                    return value;
                                },
                                requirement: requirementsByCode.COUNTRY_OF_RESIDENCE })
                        }] }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: requirementsByCode.ADDRESS,
                        fields: [{
                            id: 'addressStreet',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.addressStreet',
                                defaultMessage: 'Address Street' }),
                            field: _react3.default.createElement(_reduxForm.Field, {
                                id: 'addressStreet',
                                name: '[\'' + patchHrefs.ADDRESS + '\'].address.street',
                                hiddenValues: hiddenValues,
                                component: _components2.Input,
                                type: 'text',
                                requirement: requirementsByCode.ADDRESS })
                        }, {
                            id: 'addressCity',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.addressCity',
                                defaultMessage: 'City' }),
                            field: _react3.default.createElement(_reduxForm.Field, {
                                id: 'addressCity',
                                name: '[\'' + patchHrefs.ADDRESS + '\'].address.city',
                                hiddenValues: hiddenValues,
                                component: _components2.Input,
                                type: 'text',
                                requirement: requirementsByCode.ADDRESS })
                        }, {
                            id: 'addressState',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.addressState',
                                defaultMessage: 'State / Province / County / Region' }),
                            field: _react3.default.createElement(_reduxForm.Field, {
                                id: 'addressState',
                                name: '[\'' + patchHrefs.ADDRESS + '\'].address.state.id',
                                hiddenValues: hiddenValues,
                                component: _components2.SelectCachedInput,
                                loadResource: 'states',
                                fuzzyParam: 'name',
                                requirement: requirementsByCode.ADDRESS,
                                searchParams: [{
                                    value: this.state.countryId,
                                    name: "country.id"
                                }]
                            })
                        }, {
                            id: 'addressPostalZip',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.addressPostalZip',
                                defaultMessage: 'Postal/Zip Code' }),
                            field: _react3.default.createElement(_reduxForm.Field, {
                                id: 'addressPostalZip',
                                name: '[\'' + patchHrefs.ADDRESS + '\'].address.postal_zip',
                                hiddenValues: hiddenValues,
                                component: _components2.Input,
                                type: 'text',
                                requirement: requirementsByCode.ADDRESS })
                        }, {
                            id: 'addressCountry',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.addressCountry',
                                defaultMessage: 'Country' }),
                            field: _react3.default.createElement(_reduxForm.Field, {
                                id: 'addressCountry',
                                name: '[\'' + patchHrefs.ADDRESS + '\'].address.country.id',
                                hiddenValues: hiddenValues,
                                component: _components2.SelectInput,
                                loadResource: 'countries',
                                fuzzyParam: 'name',
                                requirement: requirementsByCode.ADDRESS }),
                            hideField: !!requirementsByCode.COUNTRY_OF_RESIDENCE
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'addressOverride',
                            requirement: requirementsByCode.ADDRESS,
                            overrideLabels: _forms.formOverrides.contactInformation.ADDRESS,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    showPhoneOverride && _react3.default.createElement(_components2.FormInstructionalText, {
                        instructionalText: _react3.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formContactInformation.instructionalText.phoneNumbers1',
                            defaultMessage: 'If you wish to provide a phone number, please\n                                                 enter {atLeastOne}.',
                            values: { atLeastOne: _react3.default.createElement(
                                    'em',
                                    null,
                                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'formContactInformation.instructionalText.phoneNumbers.atLeastOne',
                                        defaultMessage: 'at least one' })
                                )
                            } }) }),
                    !showPhoneOverride && !phoneReqIsComplete && _react3.default.createElement(_components2.FormInstructionalText, {
                        instructionalText: _react3.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formContactInformation.instructionalText.phoneNumbers2',
                            defaultMessage: 'Please provide {atLeastOne} phone number.',
                            values: { atLeastOne: _react3.default.createElement(
                                    'em',
                                    null,
                                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'formContactInformation.instructionalText.phoneNumbers.atLeastOne' })
                                )
                            } }) }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: requirementsByCode.PHONE_NUMBERS,
                        fields: [{
                            id: 'mobilePhone',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.mobilePhone',
                                defaultMessage: 'Mobile Phone #' }),
                            field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                id: 'mobilePhone',
                                name: '[\'' + patchHrefs.PHONE_NUMBERS + '\'].phone_numbers',
                                hiddenValues: hiddenValues,
                                type: 'tel',
                                requirement: requirementsByCode.PHONE_NUMBERS,
                                parse: _forms2.parsePhone
                            }, mobilePhoneRenderProps))
                        }, {
                            id: 'homePhone',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.homePhone',
                                defaultMessage: 'Home Phone #' }),
                            field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                id: 'homePhone',
                                name: '[\'' + patchHrefs.PHONE_NUMBERS + '\'].phone_numbers',
                                hiddenValues: hiddenValues,
                                type: 'tel',
                                requirement: requirementsByCode.PHONE_NUMBERS,
                                parse: _forms2.parsePhone
                            }, homePhoneRenderProps))
                        }, phoneNumberOverride] }),
                    mecMembershipNumberReq && _react3.default.createElement(_components2.FieldSet, {
                        requirement: mecMembershipNumberReq,
                        fields: [{
                            id: 'mecMembershipNumber',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.mecMembershipNumber',
                                defaultMessage: 'MEC Membership Number' }),
                            field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                id: 'mecMembershipNumber',
                                name: '[\'' + patchHrefs.ADDRESS + '\'].membership_programs',
                                hiddenValues: hiddenValues,
                                type: 'text',
                                requirement: mecMembershipNumberReq
                            }, mecMembershipRenderProps))
                        }] }),
                    paxProfile && showAlert && _react3.default.createElement(_components2.FieldSet, {
                        noRequirement: true,
                        fields: [{
                            id: 'smsAlerts',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.smsFlightAlerts',
                                defaultMessage: 'I want to receive SMS flight alerts' }),
                            field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                id: 'smsAlerts',
                                name: '[\'' + paxProfile.href + '\'].notification_preferences',
                                type: 'checkbox'
                            }, (0, _forms2.objInArrayFieldProps)({
                                findProp: 'code',
                                findValue: 'SMS_FLIGHT_ALERTS',
                                valueProp: 'subscribed',
                                WrappedComponent: _components2.Input,
                                isCheckbox: true
                            })))
                        }, {
                            id: 'emailAlerts',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formContactInformation.emailFlightAlerts',
                                defaultMessage: 'I want to receive email flight alerts' }),
                            field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                id: 'emailAlerts',
                                name: '[\'' + paxProfile.href + '\'].notification_preferences',
                                type: 'checkbox'
                            }, (0, _forms2.objInArrayFieldProps)({
                                findProp: 'code',
                                findValue: 'EMAIL_FLIGHT_ALERTS',
                                valueProp: 'subscribed',
                                WrappedComponent: _components2.Input,
                                isCheckbox: true
                            })))
                        }] }),
                    _react3.default.createElement(_components2.FormSubmit, {
                        handleSubmit: handleSubmit,
                        invalid: invalid,
                        pristine: pristine,
                        submitting: submitting,
                        submitSucceeded: submitSucceeded,
                        isFetchingRequirementData: isFetchingRequirementData })
                )
            );
        }
    }]);
    return ContactInformation;
}(_react3.default.Component)) || _class) || _class) || _class));

exports.default = (0, _reactRedux.connect)()(ContactInformation);

function _inspect(input, depth) {
    var maxDepth = 4;
    var maxKeys = 15;

    if (depth === undefined) {
        depth = 0;
    }

    depth += 1;

    if (input === null) {
        return 'null';
    } else if (input === undefined) {
        return 'void';
    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
    } else if (Array.isArray(input)) {
        if (input.length > 0) {
            if (depth > maxDepth) return '[...]';

            var first = _inspect(input[0], depth);

            if (input.every(function (item) {
                return _inspect(item, depth) === first;
            })) {
                return first.trim() + '[]';
            } else {
                return '[' + input.slice(0, maxKeys).map(function (item) {
                    return _inspect(item, depth);
                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
            }
        } else {
            return 'Array';
        }
    } else {
        var keys = (0, _keys2.default)(input);

        if (!keys.length) {
            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
                return input.constructor.name;
            } else {
                return 'Object';
            }
        }

        if (depth > maxDepth) return '{...}';
        var indent = '  '.repeat(depth - 1);
        var entries = keys.slice(0, maxKeys).map(function (key) {
            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
        }).join('\n  ' + indent);

        if (keys.length >= maxKeys) {
            entries += '\n  ' + indent + '...';
        }

        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
        } else {
            return '{\n  ' + indent + entries + '\n' + indent + '}';
        }
    }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/ContactInformation.js
// module id = 1319
// module chunks = 0